export const interpolate = (
  message: string | null | undefined,
  data: Record<string, string | number>
): string | null => {
  if (!message) {
    return null;
  }

  return message.replace(/{(.*?)}/g, (_, key) =>
    String(data[key.trim()] ?? '')
  );
};
